<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TpQ8F6/tc-custom/9781460338759.jpg?1708748468964" alt="This image is the cover for the book Not Just a Cowboy, Texas Rescue"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Not Just a Cowboy, Texas Rescue
      </h1>
      <p class="bookDescription body article font2">
        <p>A HURRICANE BROUGHT THEM TOGETHER <br/><br/>Heiress Patricia Cargill was out to prove she was more than just a big bank account. Running Texas Rescue and Relief gives her the greatest satisfaction she could imagine. Until she meets volunteer Luke Waterson. He's a little younger, a little brasher and a lot more dangerous than anyone she's dated. He could be everything she needs. <br/><br/>A STORM OF EMOTIONS COULD TEAR THEM APART <br/><br/>An unexpected change of fortune, however, reveals Luke is more than just a nomadic cowboy. Falling for a millionaire rancher, especially one who keeps secrets, was not in her plans. But committing to a man who sees her as a desirable woman, not dollar signs, could be worth making an exception to this rule.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Caro Carson
      </h2>
      
      <p class="authorDescription body article">Despite a no-nonsense background as a West Point graduate,&#160;Army officer, and Fortune 100 sales executive, Caro Carson has always treasured the happily-ever-after of a&#160;good romance novel.&#160;As&#160;a Rita-winning Harlequin author, Caro is delighted to be living her own happily-ever-after with her husband and children in&#160;Florida, a location which has saved the coaster-loving theme park fanatic a fortune on plane tickets.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f2ef16b6